import { createAsyncIcon } from '../../_factory/createAsyncIcon';

const AsyncSolarIconBoldDuotone = createAsyncIcon(() => import('./SolarIconBoldDuotone'));

export default AsyncSolarIconBoldDuotone;

AsyncSolarIconBoldDuotone.displayName = 'AsyncSolarIconBoldDuotone';
